module.exports = __webpack_public_path__ + "static/bandla-ganesh-468ea697fb5742aff31d4dcf60d3ed45.jpg";